module.exports = __webpack_public_path__ + "img/full0-min.4c9d0f2c.png";